import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-notification-management',
  templateUrl: './notification-management.component.html',
  styleUrls: ['./notification-management.component.css']
})
export class NotificationManagementComponent implements OnInit {

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  notification:any = ['']
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

 ngOnInit(): void {

  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action

  this.cid = sessionStorage.getItem('cid')
   this.getAllNotification()
 }

 onTableDataChange(event: any) {
  this.page = event.page + 1;
  // this.getAllNotification();
}

 getAllNotification(){
  this.isLoading = true

   this.generic_service.getAllNotification().subscribe(
     (res:any)=>{
       console.log(res)
       this.notification = res.response
       this.count = res.response.length
       this.isLoading = false

     },(error:any)=>{
       console.log(error)
     }
   )
 }

}